import {CrudEditHeader} from 'app/Components'
import {CrudAction, getRow, Type} from 'lib/crud'
import {name, School} from 'lib/schools'
import {State} from 'lib/store'
import * as React from 'react'
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux'
import {Form} from './Form'

type StateToProps = {
    readonly school: School
}

type DispatchToProps = {
    readonly handleSubmit: (school: School) => void,
}

type EditProps = StateToProps & DispatchToProps

class EditComponent extends React.Component<EditProps> {
    public render = () => (<>
        <CrudEditHeader actionName={name}/>
        <Form initialValues={this.props.school} handleSubmit={this.props.handleSubmit}/>
    </>)
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    school: getRow(state => state.schools)(state),
})

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, {}> = dispatch => ({
    handleSubmit: (school: School) => {
        dispatch(CrudAction.execute(name, Type.UPDATE, {id: school.id, data: school}))
    }
})

export const Edit = connect(mapStateToProps, mapDispatchToProps)(EditComponent)